// @import dependencies
// @end

// @import event types
import {IActionState,REDIRECT} from './types'
// @end

// @import utils
// @end

// @import services
// @end

// @import types
// @end

// @add your events

/*===============================================
=            Estructura de un metodo            =
================================================
  // La estructura de un metodo debe ser la siguiente:
  export const methodName = () => {}
/*======  End of Estructura de un metodo  =====*/

export function redirect(redirect:IActionState){
  return {
    type:REDIRECT,
    payload: redirect,
  }
}
//@end
